module.exports = __webpack_public_path__ + "static/img/tubiao_jinse_1.49108d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/tubiao_jinse_1.png
// module id = AcQQ
// module chunks = 2